export default __webpack_public_path__ + "static/media/usv.2650facd.webp";